import { render, staticRenderFns } from "./TourManagerIndex.vue?vue&type=template&id=f713665c"
import script from "./TourManagerIndex.vue?vue&type=script&lang=js"
export * from "./TourManagerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports